import Loader from '../assets/images/loader.gif';

export const Loading = ()=>{
    return(
        <div className='loading-before-submit'>
            <img src={Loader} alt=""/>
        </div>
    )
};